import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { GetAuthUser } from "../services/user-accounts";
import { GetMarketOffers } from "../services/user-accounts";

export default function MarketOffersListModule(props) {

  const asset = GetAuthUser();

  const [loading,setLoading]=useState(false);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setData( (await GetMarketOffers()).data)
      }
      fetchData()
    } else {}
  },[asset.usid]);

  const handleClick = async(item) =>{

  }


  return (
    <>
    <div className="row row-cols-2 row-cols-md-4">

      {data && data.map((item, i) => ( item.actv && item.sort === props.data ?
        
        <div className="col mb-3" key={i}>
          <Link to={`/offer/${item.enid}`} className="">

          <div className="layout-square mb-3">
            <img src={item.avtr} alt="" className="img-fluid rounded-wd"></img>
            <button className="btn btn-sm btn-primary rounded-pill px-3 fw-bold lead">{item.cost.toString()}</button>
          </div>
          <p className="fw-bold m-0 p-0">{item.name}</p>
          <small className="line-clamp-md text-dark">{item.shrt}</small>

          </Link>
        
        </div>
      :''))}
      </div>
    </>
  )
}